import CompanyApplications from '@/components/_templates/company/applications/Applications.vue';
import CompanyApplicationCompleted from '@/components/_templates/company/applications/CompletedApplications.vue';
import CompanyApplicationOngoing from '@/components/_templates/company/applications/OngoingApplications.vue';
import CompanyDashboard from '@/components/_templates/company/dashboard/Dashboard.vue';
import CompanyEmployees from '@/components/_templates/company/employees/Employees.vue';
import CompanyEmployeesAssignment from '@/components/_templates/company/employees/AssignmentEmployees.vue';
import CompanyEmployeesDatatable from '@/components/_templates/company/employees/EmployeesDatatable.vue';
import CompanyIndex from '@/components/_templates/company/Index.vue';
import Company from '@/components/_templates/company/Company.vue';
import CompanyJobsJob from '@/components/_templates/company/jobs/job/Job.vue';
import CompanyJobs from '@/components/_templates/company/jobs/Jobs.vue';
import CompanyJobsDatatable from '@/components/_templates/company/jobs/list/JobsDatatable.vue';
import CompanyJobsList from '@/components/_templates/company/jobs/list/List.vue';
import CompanyProfile from '@/components/_templates/company/profile/Profile.vue';
import CompanyProfileContactPerson from '@/components/_templates/company/profile/ContactPerson.vue';
import CompanyProfileGeneral from '@/components/_templates/company/profile/General.vue';
import CompanyProfileImages from '@/components/_templates/company/profile/Images.vue';
import SubscriptionAdmin from '@/components/_templates/subscription/admin/Admin.vue';
import Subscriptions from '@/components/_templates/subscription/Subscriptions.vue';
import AddCompanyForm from '@/components/_templates/company/AddCompanyForm.vue';

const companyRoutes = [
  {
    path: '/company',
    name: 'companyIndex',
    component: CompanyIndex,
    meta: { requiresAuth: true },
    children: [
      {
        path: ':companyId',
        name: 'company',
        component: Company,
        redirect: { name: 'company.dashboard' },
        meta: { requiresAuth: true },
        children: [
          {
            path: 'dashboard',
            name: 'company.dashboard',
            component: CompanyDashboard,
          },
          {
            path: 'profile',
            name: 'company.profile',
            component: CompanyProfile,
            props: true,
            redirect: { name: 'company.profile.general' },
            children: [
              {
                path: 'general',
                name: 'company.profile.general',
                component: CompanyProfileGeneral,
              },
              {
                path: 'images',
                name: 'company.profile.images',
                component: CompanyProfileImages,
              },
              {
                path: 'contact-person',
                name: 'company.profile.contactperson',
                component: CompanyProfileContactPerson,
              },
            ],
          },
          {
            path: 'jobs',
            name: 'company.jobs',
            component: CompanyJobs,
            redirect: { name: 'company.jobs.list.active' },
            children: [
              {
                path: 'list',
                name: 'company.jobs.list',
                component: CompanyJobsList,
                children: [
                  {
                    path: 'active',
                    name: 'company.jobs.list.active',
                    component: CompanyJobsDatatable,
                    meta: {
                      listType: 'activeWithRestricted',
                    },
                  },
                  {
                    path: 'draft',
                    name: 'company.jobs.list.draft',
                    component: CompanyJobsDatatable,
                    meta: {
                      listType: 'draft',
                    },
                  },
                  {
                    path: 'archived',
                    name: 'company.jobs.list.archived',
                    component: CompanyJobsDatatable,
                    meta: {
                      listType: 'trashed',
                    },
                  },
                ],
              },
              { path: 'create', name: 'company.jobs.create', component: CompanyJobsJob },
              { path: 'edit/:id', name: 'company.jobs.edit', component: CompanyJobsJob },
            ],
          },
          {
            path: 'employees',
            name: 'company.employees',
            component: CompanyEmployees,
            props: true,
            redirect: { name: 'company.employees.assignment' },
            children: [
              {
                path: 'assignment',
                name: 'company.employees.assignment',
                component: CompanyEmployeesAssignment,
                meta: {
                  listType: 'assignment',
                },
              },
              {
                path: 'all',
                name: 'company.employees.all',
                component: CompanyEmployeesDatatable,
                meta: {
                  listType: '',
                },
              },
              {
                path: 'current',
                name: 'company.employees.current',
                component: CompanyEmployeesDatatable,
                meta: {
                  listType: 'current',
                },
              },
              {
                path: 'future',
                name: 'company.employees.future',
                component: CompanyEmployeesDatatable,
                meta: {
                  listType: 'future',
                },
              },
              {
                path: 'past',
                name: 'company.employees.past',
                component: CompanyEmployeesDatatable,
                meta: {
                  listType: 'past',
                },
              },
            ],
          },
          {
            path: 'applications',
            name: 'company.applications',
            component: CompanyApplications,
            props: true,
            redirect: { name: 'company.applications.ongoing' },
            children: [
              { path: 'ongoing', name: 'company.applications.ongoing', component: CompanyApplicationOngoing },
              { path: 'completed', name: 'company.applications.completed', component: CompanyApplicationCompleted },
            ],
          },
        ],
      },
      {
        path: 'add',
        name: 'add.company',
        component: AddCompanyForm,
        meta: { requiresAuth: true },
      },
    ],
  },
  {
    path: '/subscription',
    name: 'subscription',
    component: Subscriptions,
    redirect: { name: 'subscription.admin' },
    meta: { requiresAuth: true },
    children: [
      {
        path: 'admin', name: 'subscription.admin', component: SubscriptionAdmin,
      },
    ],
  },
];

export default companyRoutes;
